{
  "license_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Licence Date",
      "width": 110,
      "isShownByDefault": true,
    },
  },
  "authorization_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licence Number",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "licensee": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Licensee",
      "isShownByDefault": true,
    },
  },
  "projected_formation": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Formations",
      "isShownByDefault": true,
    },
  },
  "fields": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Field",
      "isShownByDefault": true,
    },
  },
  "surface_uwi": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Surface Location",
      "width": 140,
      "isShownByDefault": true,
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Province",
      "width": 60,
      "isShownByDefault": true,
    },
  },
  "mineral_rights_owners": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "label": "Mineral Rights Owners",
      "width": 300,
      "isShownByDefault": true,
    },
  },
  "represented_companies": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "isNotRenderable": true,
    },
  },
  "is_land_broker": {
    "source": "regulator",
    "domainType": "boolean",
    "ui": {
      "label": "Is MR Owner Land Broker",
      "isShownByDefault": true,
    },
  },
  "color": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "isNotRenderable": true,
    },
  },
}
